import "../styles/Templates.css";
import {Badge} from "./Badge";
import * as React from "react";
import {Config} from "../Config";
import {ToolIcons} from "./Tool";
import TemplateCard from "./TemplateCard";

type FramerTemplate = {
  name: string;
  price: string;
  imageUrl?: string;
  imageUrlHover?: string;
  categories: string[];
  badge?: string;
  badgeClass?: string;
  link?: string;
};

export const Templates = () => {
  const [framerTemplates, setFramerTemplates] = React.useState<FramerTemplate[]>([]);

  React.useEffect(() => {
    let isMounted = true;

    fetch(`${process.env.PUBLIC_URL}/FramerTemplates.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to load Framer templates");
        }

        return response.json();
      })
      .then((templates: FramerTemplate[]) => {
        if (isMounted) {
          setFramerTemplates(templates);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return () => {
      isMounted = false;
    };
  }, []);

    return <div className="templates section" id={Config.PageSections.Templates}>
        <Badge icon={ToolIcons.Framer} className={"center animate-from-bottom"}>Framer templates</Badge>
        <h2 className={"animate-from-bottom delay-1"}>
            Kickstart your site with a ready-made template.
        </h2>
        <p className="subtitle animate-from-bottom delay-2">
            Browse our collection of customizable Framer templates. They’re easy to remix, stress-free to use, and help you get your site live in no time.
        </p>
        <div className="cards">
            {
                framerTemplates.length === 0 && <div className="loading-spinner">Loading...</div>
            }
            {
                framerTemplates.map((template, i) => {
                    return <TemplateCard key={"template_" + i} index={i} name={template.name} link={template.link} price={template.price} categories={template.categories} imageUrl={template.imageUrl ? (process.env.PUBLIC_URL + template.imageUrl) : undefined} imageUrlHover={template.imageUrlHover ? (process.env.PUBLIC_URL + template.imageUrlHover) : undefined} badge={template.badge} badgeClass={template.badgeClass}/>
                })
            }
        </div>
    </div>;
}
